import React, { Component } from 'react'
import {
  Icon,
  List,
  WingBlank,
  WhiteSpace,
  Button,
  InputItem,
  Pagination,
  Toast,
  NavBar,
  Modal,
  Checkbox,
  Picker,
  Accordion,
} from 'antd-mobile'
import axios from "../../../service/axios";
import { createForm } from "rc-form";
import { connect } from "dva";
import SelectGroups from "./selectGroup";
const plus_icon = require("../../../assets/images/icon/plus_icon.png");

const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;

const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "0px",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
};

const GpsInterval = [
  {
    label: <div key="1">0s</div>,
    value: 0,
  },
  {
    label: <div key="2">1分钟</div>,
    value: 60,
  },
  {
    label: <div key="3">5分钟</div>,
    value: 300,
  },
  {
    label: <div key="4">10分钟</div>,
    value: 600,
  },
];

let id = -1;

const loginAdminMsg =
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));

@connect()
export class BindingIccid extends Component {
  state = {
    funcGidArr: [],
    drawerLeft: document.body.clientWidth,
    preValidateMonth: -1,
    operators: 'cmcc',
    userType: 0
  };

  componentWillMount() {
    this.props.getFuncList();
    console.log('this.props.getFuncList();',this.props.getFuncList())
    this.getPreValidateMonth();
  }

  //获取上级管理员的时间
  getPreValidateMonth() {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/admin/preferentialMonths/get").then(res => {
        if (res.status == 200 && res.data) {
          if (res.data >= 0) {
            this.setState({
              preValidateMonth: res.data,
            });
          }
        }
      });
    });
  }

  onSave() {
    this.props.form.validateFields({ force: true }, error => {
      console.log(error);
      if (!error) {
        const fildsValue = this.props.form.getFieldsValue();
        console.log(fildsValue);
        const preferentialMonths = this.state.preValidateMonth;
        const { validMonths, iccidList } = fildsValue

        // console.log('提交?', this.state.userType)
        axios
          .post("/api/user/ptt/add/iccids", {
            ...fildsValue,
            type: this.state.userType,
            pttUserEntity: {
              ...fildsValue,
              defaultGid: this.props.defaultGroup.gid,
              gpsInterval: fildsValue.gpsInterval[0],
              validMonths: preferentialMonths > 0 ? preferentialMonths : validMonths,
              iccidList,
              type: this.state.userType
            }
          })
          .then(res => {
            console.log(res);
            if (res) {
              if (res.status == 200) {
                Toast.success(res.message, 2, () => {
                  window.history.go(-1);
                });
              } else if (res.status == 392) {
                Toast.fail("虚拟币不足");
              }
              else {
                Toast.fail(res.message);
              }
            }
          });
      }
    })
  }

  //名称校验
  validateName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        const { form } = this.props;
        let len1 = value.length;
        if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{0,13}$/.test(value)) {
          callback(new Error("名字只支持0-11位的中文、数字、字母或下划线"));
        } else if (len1 > 11) {
          callback("批量创建名称长度不超过11");
        } else {
          callback();
        }
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
  //验证密码
  validatePassword = (rule, value, callback) => {
    if (value) {
      if (
        /^[A-Za-z0-9]+$/gi.test(value) &&
        value.length <= 12 &&
        value.length >= 6
      ) {
        callback();
      } else {
        callback(new Error("请输入6-12位由数字和字母组成的密码"));
      }
    } else {
      callback(new Error("请输入密码"));
    }
  };
  //验证gps
  validateGpsinterval = (rule, value, callback) => {
    if (typeof value[0] == "number") {
      callback();
    } else {
      callback(new Error("请选择GPS上报周期"));
    }
  };
  //校验默认群组
  validateDefaultGid = (rule, value, callback) => {
    let defaultGroup = this.props.defaultGroup;
    if (defaultGroup && defaultGroup.name) {
      callback();
    } else {
      callback(new Error("请选择用户默认群组"));
    }
  };
  //连号校验ICCID
  validateIccid = (rule, value, callback) => {
    const { operators } = this.state;
    const regIccid = operators == 'cmcc' ? /^[a-zA-Z0-9]{20}$/ : /^[a-zA-Z0-9]{19}$/;
    let iccid = this.props.form.getFieldValue('iccid');
    if (iccid && regIccid.test(iccid)) {
      callback();
    } else {
      callback(new Error(`请填写${operators == 'cmcc' ? 20 : 19}位数字ICCID号码`));
    }
  };
  //非连号校验ICCID
  validateIccidList = (key, rule, value, callback) => {
    const { operators } = this.state;
    const regIccid = operators == 'cmcc' ? /^[a-zA-Z0-9]{20}$/ : /^[a-zA-Z0-9]{19}$/;
    let iccidList = this.props.form.getFieldValue('iccidList');
    console.log('key', key)
    if (iccidList && regIccid.test(iccidList[key])) {
      callback();
    } else {
      callback(new Error(`号码${key + 1}请填写${operators == 'cmcc' ? 20 : 19}位数字ICCID号码 `));
    }
  };
  validateMonths = (rule, value, callback) => {
    if (!value) {
      callback(new Error("请填写购买月数"));
    } else {
      callback();
    }
  };
  //验证账号数
  validateCreateNumber = (rule, value, callback) => {
    console.log('valueeeeee', value)
    console.log('typeof value', typeof value)
    if (/^\d{1,3}$/.test(value) && value > 0 && value <= 500) {
      callback();
    } else {
      callback(new Error("请输入1~500的数字"));
    }
  };

  //新增输入框
  addFormField = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    console.log(id)
    form.setFieldsValue({
      keys: nextKeys,
    });
  };

  //删除输入框
  removeFormField = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    if (keys.length === 0) {
      return;
    }

    const preKeys = keys.splice(0, id--);
    console.log(id)
    form.setFieldsValue({
      keys: preKeys,
    });
  };

  render() {
    const { drawerLeft, preValidateMonth, operators, userType,} = this.state
    const { addDefaultGroup, defaultGroup, funcGroupList, } = this.props
    const { getFieldProps, getFieldError, setFieldsValue, getFieldDecorator, getFieldValue } = this.props.form

    const onCheckIccidPri = (e) => {
      console.log(e.target.checked);
      setFieldsValue({
        iccidPri: e.target.checked ? 1 : 0,
      });
    }

    const onChange = (e, id, item) => {
      console.log(e.target.checked, id);
      let arr = this.state.funcGidArr;
      if (e.target.checked) {
        arr.push(item);
      } else {
        arr.splice(arr.map(item => item.id).indexOf(id), 1);
      }
      let currencyType = 1
      if (arr.length > 0) {
        currencyType = arr[0].currencyType
      } else {
        currencyType = 1
      }
      // 创建的账号类型
      let userType = 0
      if (currencyType == 4){
        userType= 4 
      } else {
        userType= 0
      }
      console.log('结果?',userType)
      setFieldsValue({
        funcsList: arr.map(item => item.id),
      });
      this.setState({
        userType:  userType,
      })
    };

    const onChangeOperators = (e) => {
      this.setState({
        operators: e,
      })
    };

    getFieldDecorator('keys', { initialValue: [] });
    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (
      <div key={index + 10}>
        {getFieldDecorator(`iccidList[${k + 1}]`, {
          rules: [
            {
              // required: true,
              validator: (rule, value, callback) => this.validateIccidList((k + 1), rule, value, callback),
              // message: `请输入${operators == 'cmcc' ? 20 : 19}位ICCID号码`,
            },
          ],
        })(
          <InputItem
            clear
            // type="number"
            placeholder={`请输入${operators == 'cmcc' ? 20 : 19}位ICCID号码`}
            minLength={operators == 'cmcc' ? 20 : 19}
            maxLength={operators == 'cmcc' ? 20 : 19}
          >
            <i className="red-star">*</i>
                号码{index + 1}
          </InputItem>
        )}
      </div>
    ));

    return (
      <div className="container">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => window.history.go(-1)}
          >
            ICCID放号
          </NavBar>
        </div>
        <div className="sub-container">
          <List
            renderFooter={() =>
              getFieldError("name") ||
              getFieldError("password") ||
              getFieldError("defaultGid") ||
              getFieldError("gpsInterval") ||
              getFieldError("funcsList") ||
              getFieldError("validMonths") ||
              getFieldError("iccid") ||
              getFieldError("iccidCount") ||
              getFieldError("agentpwd")
            }
          >
            <div>
              <InputItem
                {...getFieldProps("name", {
                  rules: [{
                    required: true,
                    validator: this.validateName,
                  }, {}],
                  initialValue: null,
                })}
                clear
                placeholder="请输入用户名称"
                key="1"
                maxLength={11}
              >
                用户名称
              </InputItem>
              <InputItem
                {...getFieldProps("password", {
                  rules: [
                    {
                      required: true,
                      validator: this.validatePassword
                    },
                  ],
                  initialValue: null,
                })}
                clear
                error={!!getFieldError("password")}
                placeholder="6-12位数字、字母组合"
                key="2"
                maxLength="12"
                type="password"
              >
                <i className="red-star">*</i>
                  密码
              </InputItem>
              <InputItem
                {...getFieldProps("defaultGid", {
                  rules: [
                    {
                      validator: this.validateDefaultGid,
                    },
                  ],
                  initialValue: defaultGroup.gid,
                })}
                key="3"
                style={{ display: 'none' }}
                value={defaultGroup.gid}
                arrow="horizontal"
                extra={
                  <span
                    onClick={() =>
                      this.setState({ drawerLeft: 0 })
                    }
                  >
                    {!defaultGroup
                      ? `点击选择默认群组`
                      : `已选择-${defaultGroup.name}`}
                  </span>
                }
                key="15"
                onClick={() => this.setState({ drawerLeft: 0 })}
                editable="false"
              >
                <i className="red-star">*</i>
                  默认群组
              </InputItem>
              <Picker
                {...getFieldProps("gpsInterval", {
                  rules: [
                    {
                      validator: this.validateGpsinterval,
                    },
                  ],
                  initialValue: [0],
                })}
                data={GpsInterval}
                cols={1}
                key="4"
                error={!!getFieldError("gpsInterval")}
              >
                <Item key="1" arrow="horizontal">
                  <i className="red-star">*</i>
                    GPS周期
                </Item>
              </Picker>
              <InputItem
                {...getFieldProps("validMonths", {
                  rules: [
                    {
                      validator: this.validateMonths,
                    },
                  ],
                  initialValue:
                    preValidateMonth > 0
                      ? (loginAdminMsg && loginAdminMsg.userValidYears == 1 ? 12 : preValidateMonth)
                      : 12,
                })}
                key="5"
                type="number"
                defaultValue={12}
                disabled={preValidateMonth > 0}
                clear
              >
                <i className="red-star">*</i>
                  购买月数
              </InputItem>
              <List>
                <Accordion defaultActiveKey="0">
                  <Accordion.Panel
                    header={
                      <div>
                        <span className="red-star">
                          *
                          </span>
                          功能组
                      </div>
                    }
                    {...getFieldProps("funcsList", {
                      rules: [
                        {
                          required: true,
                          message: "请输选择功能组"
                        },
                      ],
                    })}
                  >
                    <List className="my-list">
                      {[...funcGroupList,].map(item => {
                        return (
                          <CheckboxItem
                            key={item.id}
                            onChange={e =>
                              onChange(
                                e,
                                item.id,
                                item,
                              )
                            }
                          >
                            {item.name}
                            <Item.Brief>
                              {item.remarks}
                            </Item.Brief>
                          </CheckboxItem>
                        );
                      })}
                    </List>
                  </Accordion.Panel>
                </Accordion>
              </List>
              <List>
                <Item>
                  <Button icon={operators == 'cmcc' ? 'check-circle-o' : 'ellipsis'} type={operators == 'cmcc' ? 'primary' : ''} inline size="small" style={{ marginRight: '4px' }} onClick={() => onChangeOperators('cmcc')}>中国移动</Button>
                  <Button icon={operators == 'ctcc' ? 'check-circle-o' : 'ellipsis'} type={operators == 'ctcc' ? 'primary' : ''} inline size="small" onClick={() => onChangeOperators('ctcc')}>非中国移动</Button>
                </Item>
              </List>
              <List renderHeader={() => '连号创建'}>
                <InputItem
                  {...getFieldProps("iccid", {
                    rules: [{
                      validator: this.validateIccid,
                    }, {}],
                    initialValue: null,
                  })}
                  clear
                  // type="number"
                  placeholder={`请输入${operators == 'cmcc' ? 20 : 19}位ICCID号码`}
                  key="8"
                  minLength={operators == 'cmcc' ? 20 : 19}
                  maxLength={operators == 'cmcc' ? 20 : 19}
                >
                  <i className="red-star">*</i>
                起始号码
              </InputItem>
                <InputItem
                  {...getFieldProps("iccidCount", {
                    rules: [
                      {
                        validator: this.validateCreateNumber,
                      },
                    ],
                    initialValue: 1,
                  })}
                  clear
                  type="number"
                  placeholder="请输入1~500个创建号码数"
                  key="7"
                  maxLength={3}
                >
                  <i className="red-star">*</i>
                创建数量
              </InputItem>
              </List>
              <List>
                <Item>
                  <Item.Brief>
                    提示：填写数量为连号创建
                  </Item.Brief>
                </Item>
              </List>
              <List renderHeader={() => '非连号创建'}>
                {/* <InputItem
                  {...getFieldProps("iccidList", {
                    rules: [{
                      validator: this.validateIccid,
                    }, {}],
                    initialValue: null,
                  })}
                  clear
                  // type="number"
                  placeholder={`请输入${operators == 'cmcc' ? 20 : 19}位ICCID号码`}
                  key="8"
                  minLength={operators == 'cmcc' ? 20 : 19}
                  maxLength={operators == 'cmcc' ? 20 : 19}
                >
                  <i className="red-star">*</i>
                号码
              </InputItem> */}
                {formItems}
                <Item>
                  <div
                    style={{ width: '100%', textAlign: 'center' }}
                    onClick={() => this.addFormField()}
                  >
                    <span style={{ color: '#108ee9', textAlign: 'center' }}>+</span>添加
                  </div>
                </Item>
                <Item>
                  <div
                    style={{ width: '100%', textAlign: 'center' }}
                    onClick={() => this.removeFormField()}
                  >
                    <span style={{ color: '#108ee9', textAlign: 'center' }}>-</span>删除
                  </div>
                </Item>
              </List>
              <InputItem
                {...getFieldProps("agentpwd", {
                  rules: [{ required: true, message: "请输入经销商密码" }, {}],
                  initialValue: null,
                })}
                clear
                type="password"
                placeholder="请输入经销商密码"
                key="9"
                labelNumber="7"
                maxLength={7}
              >
                <i className="red-star">*</i>
                经销商密码
              </InputItem>
              <CheckboxItem
                {...getFieldProps("iccidPri", {
                  initialValue: 0,
                })}
                onChange={e => onCheckIccidPri(e)}
              >
                优先使用ICCID登录
              </CheckboxItem>
            </div>
            <WingBlank>
              <WhiteSpace size="xl" />
              <Button type="primary" onClick={() => this.onSave()}>
                确定
            </Button>
              <WhiteSpace size="xl" />
              <Button type="" onClick={() => window.history.go(-1)}>
                返回
            </Button>
              <WhiteSpace size="xl" />
            </WingBlank>
          </List>
        </div>
        <div
          style={{
            ...selectedContainer,
            left: drawerLeft + "px",
          }}
        >
          <SelectGroups
            defaultGroup={defaultGroup}
            addDefaultGroup={addDefaultGroup}
            handleChildClose={() =>
              this.setState({
                drawerLeft: document.body.clientWidth,
              })
            }
          />
        </div>
      </div >
    )
  }
}

const BindingIccidForm = createForm()(BindingIccid);
const mapStateToProps = state => {
  console.log(state.group)
  return {
    defaultGroup: state.group.defaultGroup,
    funcGroupList: state.app.funcGroupList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getFuncList: () => {
      dispatch({
        type: "app/getFuncGroupList",
        payload: {},
      });
    },
    addDefaultGroup: group => {
      dispatch({
        type: "group/addToDefaultGroup",
        payload: {
          group,
        },
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BindingIccidForm);
